import z from 'zod';

export const PROJECT_DETAIL_TABS = ['matching', 'chat'] as const;
export type ProjectDetailTab = (typeof PROJECT_DETAIL_TABS)[number];

export const projectDetailTabSchema = z.enum(PROJECT_DETAIL_TABS);

export const DEFAULT_PROJECT_DETAIL_TAB: ProjectDetailTab = 'chat';
